//@ts-ignore
import urlon from 'urlon';

export const urlonParse = (obj: any) => urlon.parse(obj);

export default (obj: any) => urlon.stringify(obj);
